import { ScoreGradeLevel } from "../../../../../types/gqlTypes/graphql"

export function getThresholdFromList(value, thresholds = []) {
  let index = 0

  for (let i = 0; i < thresholds.length - 1; i++) {
    if (value >= Number(thresholds[i])) {
      index = i
    }
  }
  return index
}

export const getGradeLevelIconName = (currentIndex, numberOfRanges) => {
  switch (currentIndex) {
    case numberOfRanges - 1:
      return "award"
    case 0:
      return "exclamation"
    case 1:
      return "long-arrow-right"
    case 2:
      return "check"
    case 3:
      return "check-double"
    // TODO: what are icon for level 4, 5, 6 if it's not at max?
    default:
      return "check-double"
  }
}

export const getScoreMarkerIconName = (
  gradeLevels: ScoreGradeLevel[] = [],
  score: number
) => {
  return getGradeLevelIconName(
    getThresholdFromList(
      score ?? 0,
      gradeLevels.map(level => level.score) || []
    ),
    gradeLevels.length - 1
  )
}
